import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import snakeCaseKeys from 'snakecase-keys';
import { sendAlert } from '../../../actions/utils';
import { LinkBtn, Icon } from '../../../components';
import basicDevice from './controlClock';
import ControlClockForm from './ControlClockForm';
import { showAdminDeviceRequest, updateAdminDeviceRequest } from '../../../requests/adminDevices';

const ControlClockEdit = ({ match }) => {
  const [device, setDevice] = useState(basicDevice);
  const dispatch = useDispatch();
  const history = useHistory();
  const deviceId = match.params.id;
  const requestDevice = () => {
    const request = async () => {
      showAdminDeviceRequest(deviceId, {
        dispatch,
        params: {
          method: 'edit'
        },
        successCallback: response => {
          const rawCompanies = response?.data?.companies || [];
          let sourceCompanies = [];
          if (rawCompanies.length > 0) {
            sourceCompanies = rawCompanies;
          } else if (response?.data?.company) {
            sourceCompanies = [
              {
                id: response.data.company.id,
                business_name: response.data.company.business_name,
                api_key: response.data.company.api_key,
                secret_key: response.data.company.secret_key,
                branch_office: response.data.branch_office
              }
            ];
          }

          const normalizedCompanies = sourceCompanies.map(c => {
            let compId = '';
            if (c.company_id) {
              compId = +c.company_id;
            } else if (c.id) {
              compId = +c.id;
            }
            let branchId = '';
            if (c.branch_office_id) {
              branchId = +c.branch_office_id;
            } else if (c.branch_office?.id) {
              branchId = +c.branch_office.id;
            }
            const branchName = c.branch_office_name || c.branch_office?.name || '';

            return {
              id: compId,
              company_id: compId,
              business_name: c.business_name || '',
              api_key: c.api_key || '',
              secret_key: c.secret_key || '',
              branch_office_id: branchId,
              branch_office_name: branchName,
              branch_office: {
                id: branchId,
                name: branchName
              }
            };
          });

          setDevice({
            ...response.data,
            company_id: +response?.data?.company?.id,
            branch_office_id: +response?.data?.branch_office?.id,
            companies: normalizedCompanies
          });
        }
      });
    };
    request();
  };

  const handleUpdate = values => {
    updateAdminDeviceRequest(deviceId, {
      dispatch,
      params: snakeCaseKeys(values),
      formData: true,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: `Reloj Control actualizado con éxito` }));
        history.push(`/admin/control_clock/`);
      }
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(requestDevice, []);

  return (
    <>
      <Row className="mt-4 mb-4 align-items-center">
        <Col md={1}>
          <LinkBtn variant="circle-dark" className="btn-circle mt-3" block to="/admin/control_clock">
            <Icon icon="chevron-back" />
          </LinkBtn>
        </Col>
        <Col>
          <h2 className="text-uppercase mb-0">Editar Reloj Control</h2>
        </Col>
      </Row>
      <ControlClockForm device={device} action="edit" submitVariant="success" formRequest={handleUpdate} />
    </>
  );
};

export default ControlClockEdit;
